import React, { useState } from 'react';
import StudentVideo from '../../Student/StudentVideo';
import './ReaderVideoPlayer.scss';
import { useDispatch, useSelector } from 'react-redux';
import { selectReaderVideo, playVideo, replayVideo, pauseVideo, replaceVideo, stopVideo } from './readerVideoSlice';
import cx from 'classnames';
import FaRepeat from "react-icons/lib/fa/repeat";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";

export default function ReaderVideoPlayer(props) {

    // use readerVideoSlice selector to get the videoURL and playVideo flag
    const dispatch = useDispatch();
    const { videoURL, playVideo, donePlaying, replaying, playing, replayEnabled } = useSelector(selectReaderVideo);

    // hide the video player if there is no video to play
    const videoStyle = {
        display: videoURL ? 'block' : 'none'
    };

    const onReplay = () => {
        dispatch(replayVideo());
    }

    const onDone = () => {
        dispatch(stopVideo());
    }

    const videoOverlayClasses = cx({
        'readAloudVideoOverlay': donePlaying,
        'hide': !donePlaying,
    });

    const buttonContainerClasses = cx({
        'videoPlayerButtonContainer': true,
        'fixedInPlace': true,
        'hide': !donePlaying,
    });

    const replayButtonClasses = cx({
        'inactive': !replayEnabled,
        'readAloudButton': true,
        'replay': true,
    });

    return (
        <div className="readAloudContainer" style={videoStyle}>
            <div className="readAloudVideoContainer">
                <div className={videoOverlayClasses}></div>
                <div className="readAloudVideo">
                    <StudentVideo
                        videoURL={videoURL}
                        onDone={onDone}
                        key="theOnlyStudentVideoPlayer"
                        speech={props.speech}
                        allowReplay={true}
                        autoPlay={playing}
                    />
                </div>
                {donePlaying && replayEnabled && <div className={buttonContainerClasses}>
                    <div className={replayButtonClasses} aria-label="Replay video" {...doNotUseAccessibleStaticElementInteractions({onClick: onReplay})}>
                        <FaRepeat size="70" className="buttonSvg replay" />
                        <div className="buttonLabel replay">Replay</div>
                    </div>
                </div>}
            </div>
        </div>
    );
}